import { render } from "./bbEmailCenter.vue?vue&type=template&id=cd619a4e"
import script from "./bbEmailCenter.vue?vue&type=script&lang=js"
export * from "./bbEmailCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__